export default __webpack_public_path__ + "static/media/tz.aac7f2fe.svg";